import React from 'react';
import { Modal } from 'antd';

import ODAPriceFields, { ODAFormFooter } from './ODA/ODAPriceFields';
import ODAPriceLevels from './ODA/ODAPriceLevels';
import useODAForm from './ODA/useODAForm';

type Props = {
  visible: boolean;
  hide: () => void;
  id: number;
};

const ODAModal: React.FC<Props> = ({ visible, hide, id }) => {
  const form = useODAForm(id, hide);

  return (
    <Modal
      open={visible}
      className="oda-modal"
      width={{ xs: 400, sm: 400, md: 704 }}
      title={`ODA ${form.name}`}
      onCancel={hide}
      footer={<ODAFormFooter form={form} />}
    >
      <div className="oda-layout oda-layout--beside">
        <ODAPriceFields form={form} />
        <ODAPriceLevels form={form} />
      </div>
    </Modal>
  );
};

export default ODAModal;
